"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.useForceUpdate = useForceUpdate;
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
var _react = require("react");
/**
 * Debounced so that re-renders are batched no matter the cause. https://github.com/facebook/react/issues/14259#issuecomment-439632622
 * @returns {function}
 */
function useForceUpdate() {
  const [, updateState] = (0, _react.useState)({});
  const forceUpdate = (0, _react.useCallback)((0, _debounce2.default)(() => updateState({})), []);
  return callback => {
    if (typeof callback === 'function') {
      callback();
    }
    forceUpdate();
  };
}